import { comicCategories } from "@/mocks/comics";

const quickLinks = [
  { href: "#vip", label: "会员特权" },
  { href: "#hot", label: "热门漫画" },
  { href: "#category", label: "漫画分类" },
  { href: "#experience", label: "阅读体验" },
  { href: "#pricing", label: "尊享套餐" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-700/60 bg-background-900/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-gemini-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                韩漫<span className="text-gradient-gold">土豪</span>漫画网
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              专注原版韩漫的尊享阅读平台，VIP 章节付费解锁抢先看，高画质无广告，只为满足你的尊享阅读需求。
            </p>
            <div className="mt-5 flex gap-2.5">
              {["ri-weibo-line", "ri-wechat-line", "ri-tiktok-line", "ri-douban-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-600 text-foreground-400 transition-colors hover:border-primary-500/60 hover:text-primary-400"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="快捷导航">
            <h3 className="text-sm font-semibold text-foreground-50">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="漫画分类">
            <h3 className="text-sm font-semibold text-foreground-50">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {comicCategories.map((c) => (
                <li key={c.name}>
                  <a href="#hot" className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-semibold text-foreground-50">联系方式</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-primary-400"></i>
                support@hanman-tuhao.example.com
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-primary-400"></i>
                客服在线 9:00 - 22:00
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                黄金会员一对一专属服务
              </li>
            </ul>
            <a
              href="#subscribe"
              className="mt-4 inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-primary-500/50 px-4 py-2.5 text-sm font-medium text-primary-300 transition-colors hover:bg-primary-500/10"
            >
              <i className="ri-mail-send-line"></i>
              订阅更新通知
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 韩漫土豪漫画网 · 尊享高画质无广告阅读平台
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#about" className="transition-colors hover:text-primary-300">关于我们</a>
            <span className="mx-2">·</span>
            <a href="#faq" className="transition-colors hover:text-primary-300">帮助中心</a>
          </p>
        </div>
      </div>
    </footer>
  );
}